import Link from "next/link";
import { useRouter } from "next/router";
import ReactCountryFlag from "react-country-flag";

const LanguageFlags: React.FC = () => {
  const router = useRouter();

  const currentLanguage = router.locale?.toUpperCase();

  const showPlFlag = currentLanguage === "EN";
  const showUsFlag = currentLanguage === "PL";

  return (
    <div className="fixed right-4 bottom-3 z-[999]">
      {showPlFlag && (
        <Link href={router.pathname} locale="pl" passHref>
          <button
            aria-label="Change language to Polish"
            className="group relative w-12 h-12 flex items-center justify-center rounded-full bg-vintage-cream/95 border-2 border-vintage-ochre/50 shadow-vintage hover:shadow-vintage-lg hover:border-vintage-ochre transition-all duration-300 hover:-translate-y-1"
          >
            {/* Inner decorative ring */}
            <div className="absolute inset-1 rounded-full border border-vintage-walnut/10" />
            <ReactCountryFlag
              countryCode="PL"
              style={{ fontSize: "1.5em" }}
              className="relative z-10"
            />
          </button>
        </Link>
      )}
      {showUsFlag && (
        <Link href={router.pathname} locale="en" passHref>
          <button
            aria-label="Change language to English"
            className="group relative w-12 h-12 flex items-center justify-center rounded-full bg-vintage-cream/95 border-2 border-vintage-ochre/50 shadow-vintage hover:shadow-vintage-lg hover:border-vintage-ochre transition-all duration-300 hover:-translate-y-1"
          >
            {/* Inner decorative ring */}
            <div className="absolute inset-1 rounded-full border border-vintage-walnut/10" />
            <ReactCountryFlag
              countryCode="GB"
              style={{ fontSize: "1.5em" }}
              className="relative z-10"
            />
          </button>
        </Link>
      )}
    </div>
  );
};

export default LanguageFlags;
